import styled from '@emotion/styled';
import { childCoachCommentButtonVisibilityStyling } from '../../../FieldWrapper/StyledFieldWrapper';
import CommentWrapper from '@/components/comment/CommentWrapper';

const StyledLogEntry = styled(CommentWrapper.withComponent('article'))(
  ({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    transition: theme.transitions.create('all'),
    ...childCoachCommentButtonVisibilityStyling,
  }),
);

export default StyledLogEntry;
